"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var react_i18next_1 = require("react-i18next");
var useCarolineSession_1 = __importDefault(require("stremio/caroline/auth/useCarolineSession"));
var styles_less_1 = __importDefault(require("./styles.less"));
var CarolineDeviceAuthorization = function () {
    var t = (0, react_i18next_1.useTranslation)().t;
    var location = (0, react_router_dom_1.useLocation)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var session = (0, useCarolineSession_1.default)();
    var _a = react_1.default.useState(''), enteredCode = _a[0], setEnteredCode = _a[1];
    var _b = react_1.default.useState(''), submittedCode = _b[0], setSubmittedCode = _b[1];
    var query = new URLSearchParams("".concat(window.location.search, "&").concat(location.search));
    var userCode = (query.get('user_code') || submittedCode).replace(/[^a-z0-9]/gi, '').toUpperCase();
    var _c = react_1.default.useState(null), clientId = _c[0], setClientId = _c[1];
    var _d = react_1.default.useState('loading'), status = _d[0], setStatus = _d[1];
    var _e = react_1.default.useState('A verificar o código…'), message = _e[0], setMessage = _e[1];
    var _f = react_1.default.useState(false), submitting = _f[0], setSubmitting = _f[1];
    react_1.default.useEffect(function () {
        if (session.status !== 'authenticated' || !userCode)
            return;
        var active = true;
        fetch("/api/auth/device?user_code=".concat(encodeURIComponent(userCode)), { credentials: 'include', cache: 'no-store' })
            .then(function (response) { return __awaiter(void 0, void 0, void 0, function () {
            var result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, response.json()];
                    case 1:
                        result = _a.sent();
                        if (!response.ok)
                            throw new Error(result.error_description || 'O código expirou ou não é válido.');
                        if (active) {
                            setClientId(typeof result.client_id === 'string' ? result.client_id : 'Dispositivo Caroline');
                            setStatus(result.status === 'approved' ? 'approved' : 'ready');
                            setMessage(result.status === 'approved' ? 'Este dispositivo já foi autorizado.' : 'Confirma que queres ligar este dispositivo à tua conta.');
                        }
                        return [2 /*return*/];
                }
            });
        }); })
            .catch(function (error) {
            if (active) {
                setStatus('error');
                setMessage(error instanceof Error ? error.message : 'Não foi possível validar o código.');
            }
        });
        return function () { active = false; };
    }, [session.status, userCode]);
    var authorize = function (action) { return __awaiter(void 0, void 0, void 0, function () {
        var response, result, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSubmitting(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, fetch("/api/auth/device/".concat(action), {
                            method: 'POST', credentials: 'include',
                            headers: { 'content-type': 'application/json' },
                            body: JSON.stringify({ userCode: userCode }),
                        })];
                case 2:
                    response = _a.sent();
                    return [4 /*yield*/, response.json()];
                case 3:
                    result = _a.sent();
                    if (!response.ok)
                        throw new Error(result.error_description || 'Não foi possível actualizar a autorização.');
                    setStatus(action === 'approve' ? 'approved' : 'error');
                    setMessage(action === 'approve' ? 'Autorizado. Já podes voltar à televisão.' : 'Pedido recusado.');
                    return [3 /*break*/, 6];
                case 4:
                    error_1 = _a.sent();
                    setStatus('error');
                    setMessage(error_1 instanceof Error ? error_1.message : 'Não foi possível contactar Caroline.');
                    return [3 /*break*/, 6];
                case 5:
                    setSubmitting(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    var returnTo = userCode ? "/device?user_code=".concat(encodeURIComponent(userCode)) : '/device';
    var loginHref = "#/caroline-auth?returnTo=".concat(encodeURIComponent(returnTo));
    return (react_1.default.createElement("main", { className: styles_less_1.default.page },
        react_1.default.createElement("section", { className: styles_less_1.default.panel },
            react_1.default.createElement("p", { className: styles_less_1.default.eyebrow }, t('CAROLINE_DEVICE_PAIRING', { defaultValue: 'CAROLINE · EMPARELHAMENTO' })),
            react_1.default.createElement("h1", null, t('CAROLINE_DEVICE_LINK_TITLE', { defaultValue: 'Ligar dispositivo' })),
            !userCode && react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("p", null, t('CAROLINE_DEVICE_ENTER_CODE', { defaultValue: 'Introduz o código apresentado na televisão.' })),
                react_1.default.createElement("label", { className: styles_less_1.default.codeField },
                    t('CAROLINE_DEVICE_CODE_LABEL', { defaultValue: 'Código do dispositivo' }),
                    react_1.default.createElement("input", { "aria-label": t('CAROLINE_DEVICE_CODE_LABEL', { defaultValue: 'Código do dispositivo' }), value: enteredCode, onChange: function (event) { return setEnteredCode(event.target.value); }, autoCapitalize: "characters", autoComplete: "off" })),
                session.status === 'unauthenticated' && enteredCode.trim() && react_1.default.createElement("a", { className: styles_less_1.default.primary, href: "#/caroline-auth?returnTo=".concat(encodeURIComponent("/device?user_code=".concat(encodeURIComponent(enteredCode)))) }, t('CAROLINE_DEVICE_CONTINUE_SIGN_IN', { defaultValue: 'Continuar para iniciar sessão' })),
                session.status === 'authenticated' && react_1.default.createElement("button", { type: "button", disabled: !enteredCode.trim(), onClick: function () { setStatus('loading'); setSubmittedCode(enteredCode); } }, t('CAROLINE_DEVICE_CONFIRM_CODE', { defaultValue: 'Confirmar código' }))),
            session.status === 'loading' && react_1.default.createElement("p", { role: "status" }, t('CAROLINE_DEVICE_CHECKING_SESSION', { defaultValue: 'A verificar a sessão da conta…' })),
            session.status === 'unavailable' && react_1.default.createElement("p", { role: "alert" }, t('CAROLINE_DEVICE_SERVICE_UNAVAILABLE', { defaultValue: 'O serviço de conta está temporariamente indisponível.' })),
            session.status === 'unauthenticated' && userCode && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("p", null, t('CAROLINE_DEVICE_SIGN_IN_TO_APPROVE', { defaultValue: 'Inicia sessão na Caroline para rever e aprovar este pedido.' })),
                react_1.default.createElement("a", { className: styles_less_1.default.primary, href: loginHref }, t('CAROLINE_AUTH_SIGN_IN', { defaultValue: 'Iniciar sessão' })))),
            session.status === 'authenticated' && userCode && react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("p", { className: styles_less_1.default.code }, userCode),
                react_1.default.createElement("p", null, message),
                clientId && react_1.default.createElement("p", { className: styles_less_1.default.device },
                    t('CAROLINE_DEVICE_REQUESTED_BY', { defaultValue: 'Pedido de:' }),
                    " ",
                    clientId),
                status === 'ready' && react_1.default.createElement("div", { className: styles_less_1.default.actions },
                    react_1.default.createElement("button", { type: "button", disabled: submitting, onClick: function () { return authorize('approve'); } }, t('CAROLINE_DEVICE_APPROVE', { defaultValue: 'Autorizar dispositivo' })),
                    react_1.default.createElement("button", { className: styles_less_1.default.secondary, type: "button", disabled: submitting, onClick: function () { return authorize('deny'); } }, t('CAROLINE_DEVICE_DENY', { defaultValue: 'Recusar' }))),
                status === 'approved' && react_1.default.createElement("button", { type: "button", onClick: function () { return navigate('/', { replace: true }); } }, t('CAROLINE_DEVICE_DONE', { defaultValue: 'Concluído' }))))));
};
exports.default = CarolineDeviceAuthorization;
